class CyclewayLayer extends Layer {

  constructor(mapGL, isVisible = false) {
    super(mapGL, isVisible);

    this.name = 'cycleway';
    this.minZoom = 11;
    this.layerIds = ['cycleway'];

    this.isClickable = false;

    this.load();
  }

  load() {

    var tileSize = 256;
    var url = 'https://download.data.grandlyon.com/wms/grandlyon?' +
      '&LAYERS=pvo_patrimoine_voirie.pvoamenagementcyclable' +
      '&FORMAT=image/png' +
      '&DPI=72' +
      '&BGCOLOR=0xFFFFFF' +
      '&TRANSPARENT=TRUE' +
      '&VERSION=1.3.0' +
      '&EXCEPTIONS=INIMAGE' +
      '&REQUEST=GetMap' +
      '&CRS=EPSG:3857' +
      '&SERVICE=WMS' +
      '&WIDTH=' + tileSize +
      '&HEIGHT=' + tileSize +
      '&BBOX={bbox-epsg-3857}';

    this.mapGL.getMapObject().addSource(this.name + '-source', {
      'type': 'raster',
      'tiles' : [url],
      'tileSize': tileSize
    });

    this.mapGL.getMapObject().addLayer({
      'id': this.layerIds[0],
      'type': 'raster',
      'source': this.name + '-source',
      'paint': {},
      'layout': {
        'visibility': this.isVisible ? 'visible' : 'none'
      },
      'minzoom': this.minZoom,
    }, 'poi_label');
  }

}
